import { HOST } from '../utils/constants';
import { Discount, DiscountPayload } from './discountTypes';

const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const fetchDiscounts = async (): Promise<Discount[]> => {
  const res = await fetch(`${HOST}/discounts`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error('Error al obtener descuentos');
  return res.json();
};

export const createDiscount = async (
  payload: DiscountPayload
): Promise<Discount> => {
  const res = await fetch(`${HOST}/discounts`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const msg =
      res.status === 409
        ? 'Ya existe un descuento activo para ese medio de pago en ese período'
        : data.message || 'Error al crear descuento';
    throw new Error(msg);
  }
  return res.json();
};

export const updateDiscount = async (
  id: string,
  payload: DiscountPayload
): Promise<Discount> => {
  const res = await fetch(`${HOST}/discounts/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const msg =
      res.status === 409
        ? 'Ya existe un descuento activo para ese medio de pago en ese período'
        : data.message || 'Error al editar descuento';
    throw new Error(msg);
  }
  return res.json();
};

export const deleteDiscount = async (id: string): Promise<void> => {
  const res = await fetch(`${HOST}/discounts/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Error al eliminar descuento');
};

export const fetchActiveDiscount = async (
  paymentMethod: string
): Promise<Discount | null> => {
  const res = await fetch(
    `${HOST}/discounts/active?paymentMethod=${encodeURIComponent(paymentMethod)}`
  );
  if (!res.ok) return null;
  const text = await res.text();
  if (!text) return null;
  const data = JSON.parse(text);
  return data || null;
};
